import { Component, OnInit, OnDestroy } from '@angular/core';
import { ManageInvoiceRebService } from './manage-invoice-reb.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TokenStorageService } from '../services/auth-user-service/token-storage.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';

import { IInvoiceReb, IProjectInvoicesRebResponse } from './manage-invoice-reb.interfaces';
import { DialogFacturesReb } from '../dialog/factures-reb/dialog.component.factures-reb';

import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'mcrit-gestio-manage-invoice-reb',
  templateUrl: './manage-invoice-reb.component.html',
  styleUrls: ['./manage-invoice-reb.component.scss']
})

export class ManageInvoiceRebComponent implements OnInit, OnDestroy {
  private routeParamsSubs: any;
  public userInfo: any = {};
  private invoiceModel: IInvoiceReb = {
      'id': 'NEW',
      'projecte_codi': '',
      'fita': '',
      'objecte_lliurament': '',
      'facturacio_prevista_percent': 0,
      'facturacio_prevista_eur': 0,
      'facturacio_loc': 0,  
      'moneda_facturacio': '', 
      'canvi_moneda': 0,
      'subcontractacio': 0,
      'numero_factura': null,
      'observacions': null,
      'data_factura': null,
      'data_pagament': null,
      'data_factura_prevista': (new Date()).toISOString().slice(0, 10),
      'data_pagament_prevista': null,
      'impostos': 0,
      'concepte': '',
      'activa': true,
      'clau': ''
  };
  private projectCode: string;
  private unsubscriber : Subject<void> = new Subject<void>();
  
  public showDialog: boolean = false;
  public showAsyncProgress: boolean = false;
  public invoicingData: IProjectInvoicesRebResponse;
  public editInvoiceData: IInvoiceReb;
  public acumulat = {
    facturat: 0,
    cobrat: 0,
    concepte: ''
  };

  public editInvoice(invoice: IInvoiceReb): void {
    this.editInvoiceData = Object.assign(
      {},
      this.invoiceModel,
      invoice
    );
   this.editInvoiceData.clau = this.invoicingData.projectData["clau"];

   let dialogFactRef=this.dialog.open(DialogFacturesReb, {disableClose: true, data: this.editInvoiceData })
   
   dialogFactRef.afterClosed().subscribe(results => {
     if(!results)return;
     this.editInvoiceData = results;
     this.addOrUpdateUser();
   });
  }

  public addInvoice(): void {
    this.editInvoiceData = Object.assign(
      {},
      this.invoiceModel,
      { projecte_codi : this.projectCode }
    );
    this.editInvoiceData.clau = this.invoicingData.projectData["clau"];

    let dialogFactRef=this.dialog.open(DialogFacturesReb, {data: this.editInvoiceData })
   
    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editInvoiceData = results;
      this.addOrUpdateUser();
    });

    //this.showDialog = true;
  }

  public addOrUpdateUser(/*$event*/): void {
    //$event.preventDefault();
    this.showAsyncProgress = true;
    this.showDialog = false;
    if (this.editInvoiceData.id === 'NEW') {
      this.manageInvoiceService.create(this.editInvoiceData)
        .subscribe(newInvoice => {
          this.invoicingData.invoices = [newInvoice, ...this.invoicingData.invoices];
          this.showAsyncProgress = false;
        },
          err => console.log(err)
        );
    } else {
      this.manageInvoiceService.update(<number> this.editInvoiceData.id, this.editInvoiceData)
        .subscribe(updatedInvoice => {
          this.invoicingData.invoices = this.invoicingData.invoices.map(invoice => {
            return (invoice.id === updatedInvoice.id ? updatedInvoice : invoice);
          },
          err => console.log(err)
        );
          this.showAsyncProgress = false;
        });
    }
  }

  public deleteInvoice(invoiceToDelete: IInvoiceReb): void {
    if(confirm("Confirma l'esborrat de la factura")){
      this.showAsyncProgress = true;
      this.showDialog = false;
      this.manageInvoiceService.destroy(<number> invoiceToDelete.id)
        .subscribe(deletedInvoice => {
          this.invoicingData.invoices = this.invoicingData.invoices
           .filter(invoice => invoice.id !== deletedInvoice.id);
          this.showAsyncProgress = false;
        },
         err => console.log(err)
        );
    }
  }

  public goProject(){ this.router.navigate(['project',this.invoicingData.projectData.codi]);};
  
  public export(){
    var csvData = this.convertToCSV( this.invoicingData.invoices);
    var a = document.createElement("a");
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    var blob = new Blob([csvData.replace(/,/g,"").replace(/\./g,",")], { type: 'text/csv' });
    var url= window.URL.createObjectURL(blob);
    a.href = url;
    var x:Date = new Date();
    var link:string ="factures_"+this.invoicingData.projectData.codi+"_"+ x.getMonth() +  "_" +  x.getDay() + '.csv';
    a.download = link.toLocaleLowerCase();
    a.click();
  }

  private convertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = "";

    for (var index in objArray[0])row += index + ';';
    row = row.slice(0, -1);
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ';'
            line += array[i][index];
        }
        str += line + '\r\n';
    }
    return str;
  }

  constructor(public translate: TranslateService, public languageService: LanguageService, private manageInvoiceService: ManageInvoiceRebService, private tokenStorage: TokenStorageService, private route: ActivatedRoute, public dialog:MatDialog, private router: Router) { 
  this.userInfo = this.tokenStorage.getUser();}

  ngOnInit() {
    this.routeParamsSubs = this.route.params.subscribe(params => {
      this.projectCode = params['id'];
      this.manageInvoiceService.getByProject(this.projectCode)
          .subscribe(
            data => {console.log(data);
              this.invoicingData = data;
            },
            error => console.log(error)
          );
    });
    
    history.pushState(null,  document.title, location.href);

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });

  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
    this.routeParamsSubs.unsubscribe();
  }

}
